import { Helmet } from "react-helmet";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import BookADemoSection from "./BookADemoSection";
import DemoVideoSection from "./DemoVideoSection";
import React from "react";

export default function BookademoPage() {
  return (
    <>
      <Helmet>
        <title>Book a Demo with Zwilling Labs - Optimize Your Operations</title>
        <meta
          name="description"
          content="Discover how Zwilling Labs' digital solutions can enhance your operational efficiency. Book a demo today and take the first step towards smoother compliance and optimization."
        />
      </Helmet>
      <div className="w-full bg-white">
        <Header className="rounded-bl-[20px] rounded-br-[20px] bg-blue_gray-900" />

        {/* book a demo section */}
        <BookADemoSection />

        {/* demo video section */}
        <DemoVideoSection />
        <Footer className="rounded-tl-[34px] rounded-tr-[34px] bg-gradient1 sm:py-5" />
      </div>
    </>
  );
}
